import React, { Fragment, useEffect ,useState} from "react";
import { Card, CardBody,CardHeader } from "reactstrap";
import DataTable from "react-data-table-component";
import { getUnAssignedTrips } from "../../../Services/DispatchDashboard.service";
import { Link } from "react-router-dom";
import moment from "moment";
import CommonToolTip from "../../Common/Component/CommonToolTip";
import StatusIcons from "../../../CommonElements/StatusIcons";
import { Spinner } from "../../../AbstractElements";
const columns = [
  {
    name: "BOOKING #",
    selector: (row) => row["booking_number"],
    sortable: true,
    // center: true,
    width:"130px",
  },
  {
    name: (
      <span>
        <Fragment>
          PICKUP <i className="fa fa-clock-o mr-2"></i>
        </Fragment>
      </span>
    ),
    selector: (row) => row["pickup_time"],
    sortable: true,
    // center: true,
    // width:"130px",
  },
  {
    name: "CUSTOMER NAME",
    selector: (row) => row["customer_name"],
    sortable: true,
    // center: true,
    // width:"130px",
  },
  {
    name: "PHONE #",
    selector: (row) => row["phone_number"],
    sortable: true,
    // center: true,
    // width:"130px",
  },
  {
    name: "PICKUP",
    selector: (row) => row["pickup_location"],
    sortable: true,
    // center: true,
    // maxWidth:"7vw",
  },
  {
    name: "DROP",
    selector: (row) => row["drop_location"],
    sortable: true,
    // center: true,
    // maxWidth:"7vw",
  },
  {
    name: "STATUS",
    selector: (row) => row["status"],
    sortable: true,
    // center: true,
    // width:"100px",
  },
  {
    name: "BOOKING VIA",
    selector: (row) => row["booking_via"],
    sortable: true,
    // center: true,
    // width:"120px",
  },
];

const data = [
  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },
];

const CurrentUnassignedTripsTable = ({globalCityField}) => {
  const [tableData,setTableData] = useState([])
  const [loader,setLoader] = useState(false)
  useEffect(()=>{
    setLoader(true)
    const serviceCityId = globalCityField.value?.id || null
    let body={
      serviceCityId
    }
    getUnAssignedTrips(body).then(result=>{
      setLoader(false)
      if(result.data){
        const processData = result.data.map((element, index) => {
          return {
            booking_number: (
              <Link
                to={`${process.env.PUBLIC_URL}/booking/booking-info/${element.id}`}
              >
                {element.megaCabsBookingNo}
              </Link>
            ),
            pickup_time: element.pickUpDateTime
              ? moment(new Date(element.pickUpDateTime)).format("MMM DD HH:mm")
              : "-",
            customer_name: element.custName ? element.custName : "-",
            phone_number: element.custMobile ? element.custMobile : "-",
            pickup_location: element.pickUpAddress
              ? // <>
                //   <span id={"pickupLocation" + index}>{element.pickUpAddress}</span>
                //   <CommonToolTip
                //     options={{
                //       placement: "left",
                //       target: "pickupLocation" + index,
                //     }}
                //   >
                //     {element.pickUpAddress}
                //   </CommonToolTip>
                // </>
                element.pickUpAddress
              : "-",
            drop_location: element.destAddress ? (
              <>
                <span id={"dropLocation" + index}>
                  {element.destAddress.includes("Kempegowda")
                    ? "Kempegowda Airport"
                    : element.destAddress}
                </span>
                <CommonToolTip
                  options={{
                    placement: "left",
                    target: "dropLocation" + index,
                  }}
                >
                  {element.destAddress}
                </CommonToolTip>
              </>
            ) : (
              "-"
            ),
            status: element.currentBookingStatusType ? (
              <>
                <span className="status-icon">
                  <span id={"statusIcons" + index}>
                    <StatusIcons statusType={element.currentBookingStatusType} />
                  </span>
                  <CommonToolTip
                    options={{
                      placement: "left",
                      target: "statusIcons" + index,
                    }}
                  >
                    {element.currentBookingStatusType}
                  </CommonToolTip>
                </span>
              </>
            ) : (
              "-"
            ),
            booking_via: element.bookingViaType ? element.bookingViaType : "-",
          };
        });
        setTableData(processData)
      }
    }).catch(err=>{
      setLoader(false)
    })
  },[globalCityField.value])
  return (
    <Fragment>
      <Card className="unassigned-trips-table">
        <CardHeader>
          <div className="calendar-icon">
          <i className="fa fa-calendar"></i>
          </div>
          <div className="unassigned-trip-table-content">
            <div className="unassigned-trip-table-title">Unassigned Trips</div>
            <div className="unassigned-trip-table-length">{tableData.length}</div>
          </div>
        </CardHeader>
        <CardBody>
          <div className="table-responsive support-table">
            <DataTable
              columns={columns}
              data={tableData}
              center={true}
              fixedHeader
              pagination
              fixedHeaderScrollHeight="50vh"
              // customStyles={customStyles}
              progressPending={loader}
              progressComponent={<div className="loader-box" style={{ height: "50vh" }}>
                <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
              </div>}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default CurrentUnassignedTripsTable;
